var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 120,
    viewBox: "0 0 136 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_1630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.976 56.4684C116.267 56.4684 116.542 56.3533 116.747 56.1476C117.521 55.3619 135.653 36.7571 135.653 19.7564C135.653 8.86004 126.827 0.00390625 115.972 0.00390625C105.117 0.00390625 96.2949 8.86415 96.2949 19.7564C96.2949 36.7571 114.431 55.3661 115.202 56.1476C115.407 56.3533 115.685 56.4684 115.972 56.4684H115.976ZM106.011 19.7523C106.011 14.228 110.473 9.74853 115.976 9.74853C121.479 9.74853 125.942 14.228 125.942 19.7523C125.942 25.2766 121.479 29.7561 115.976 29.7561C110.473 29.7561 106.011 25.2766 106.011 19.7523Z",
    fill: "url(#paint0_linear_727_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.742 72.0829C18.7585 70.3183 16.5376 69.6766 14.7715 70.6803C13.0136 71.6675 12.3866 73.9011 13.3742 75.6698C14.7715 78.1666 16.763 80.3303 19.1314 81.9222C19.7543 82.3376 20.4632 82.5392 21.1598 82.5392C22.3399 82.5392 23.4955 81.9715 24.2003 80.9144C25.3189 79.2279 24.8723 76.9532 23.1963 75.8261C21.7744 74.8718 20.5779 73.5761 19.742 72.0788V72.0829Z",
    fill: "url(#paint1_linear_727_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8567 77.6606H33.0094C30.9934 77.6606 29.3584 79.3019 29.3584 81.3257C29.3584 83.3495 30.9934 84.9907 33.0094 84.9907H39.8567C41.8728 84.9907 43.5077 83.3495 43.5077 81.3257C43.5077 79.3019 41.8728 77.6606 39.8567 77.6606Z",
    fill: "url(#paint2_linear_727_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4934 106.742H28.6462C26.6301 106.742 24.9951 108.383 24.9951 110.407C24.9951 112.431 26.6301 114.072 28.6462 114.072H35.4934C37.5095 114.072 39.1444 112.431 39.1444 110.407C39.1444 108.383 37.5095 106.742 35.4934 106.742Z",
    fill: "url(#paint3_linear_727_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3251 65.3781C14.7307 65.5221 15.1446 65.5879 15.5503 65.5879C17.0541 65.5879 18.4555 64.6541 18.9923 63.1527C19.5619 61.5403 20.5208 60.0636 21.7665 58.883C23.2334 57.4927 23.2949 55.1728 21.9099 53.7002C20.529 52.2317 18.2097 52.1659 16.7468 53.5562C14.6693 55.5265 13.0671 57.9945 12.1082 60.6888C11.4362 62.6015 12.4237 64.6953 14.3251 65.374V65.3781Z",
    fill: "url(#paint4_linear_727_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5553 55.9053H37.4026C39.4186 55.9053 41.0536 54.264 41.0536 52.2402C41.0536 50.2164 39.4186 48.5752 37.4026 48.5752H30.5553C28.5393 48.5752 26.9043 50.2164 26.9043 52.2402C26.9043 54.264 28.5393 55.9053 30.5553 55.9053Z",
    fill: "url(#paint5_linear_727_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9482 90.9675C61.9362 91.1403 60.4528 92.9172 60.6249 94.9369C60.6536 95.2454 60.6659 95.5539 60.6659 95.8665C60.6659 97.2898 60.3996 98.6678 59.8669 99.9717C59.1088 101.847 60.0062 103.986 61.8747 104.751C62.3255 104.937 62.7926 105.019 63.2516 105.019C64.6898 105.019 66.0544 104.159 66.6363 102.736C67.5173 100.552 67.968 98.2441 67.968 95.8665C67.968 95.34 67.9475 94.8135 67.9024 94.2993C67.7303 92.2797 65.9478 90.8318 63.9482 90.9634V90.9675Z",
    fill: "url(#paint6_linear_727_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5873 81.2024C58.2762 79.4953 55.5717 78.3559 52.7525 77.8952C50.7897 77.5867 48.8884 78.9277 48.5606 80.9309C48.2409 82.9259 49.5891 84.8098 51.5847 85.1389C53.2606 85.4104 54.8751 86.0932 56.2519 87.1133C56.9035 87.5905 57.6656 87.8249 58.4155 87.8249C59.5383 87.8249 60.6446 87.3107 61.3617 86.3359C62.5583 84.7029 62.21 82.4117 60.5873 81.2065V81.2024Z",
    fill: "url(#paint7_linear_727_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3878 106.146C52.2404 106.545 51.048 106.747 49.831 106.747H47.819C45.8029 106.747 44.168 108.388 44.168 110.412C44.168 112.435 45.8029 114.077 47.819 114.077H49.831C51.8593 114.077 53.8549 113.739 55.7685 113.081C57.674 112.419 58.6902 110.333 58.0346 108.417C57.3789 106.504 55.3137 105.484 53.3878 106.142V106.146Z",
    fill: "url(#paint8_linear_727_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3213 100.823C5.04752 100.823 0.769531 105.114 0.769531 110.412C0.769531 115.71 5.04752 120 10.3213 120C15.595 120 19.873 115.71 19.873 110.412C19.873 105.114 15.595 100.823 10.3213 100.823Z",
    fill: "url(#paint9_linear_727_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0477 37.1849C78.6217 35.7535 76.3106 35.7535 74.8846 37.1849C73.4586 38.6164 73.4586 40.9363 74.8846 42.3678L81.068 48.5749H49.8395C47.8235 48.5749 46.1885 50.2161 46.1885 52.2399C46.1885 54.2637 47.8235 55.905 49.8395 55.905H81.068L74.8846 62.1121C73.4586 63.5435 73.4586 65.8635 74.8846 67.295C75.5976 68.0107 76.5278 68.3686 77.4662 68.3686C78.4045 68.3686 79.3347 68.0107 80.0477 67.295L92.4637 54.8314C93.8897 53.3999 93.8897 51.08 92.4637 49.6485L80.0477 37.1849Z",
    fill: "url(#paint10_linear_727_1630)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_727_1630",
    x1: 115.974,
    y1: 0.00390625,
    x2: 115.974,
    y2: 56.4684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_727_1630",
    x1: 18.8612,
    y1: 70.2051,
    x2: 18.8612,
    y2: 82.5392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECF74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_727_1630",
    x1: 36.4331,
    y1: 77.6606,
    x2: 36.4331,
    y2: 84.9907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECF74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_727_1630",
    x1: 32.0698,
    y1: 106.742,
    x2: 32.0698,
    y2: 114.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECF74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_727_1630",
    x1: 17.4033,
    y1: 52.5547,
    x2: 17.4033,
    y2: 65.5879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECF74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_727_1630",
    x1: 33.979,
    y1: 48.5752,
    x2: 33.979,
    y2: 55.9053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECF74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_727_1630",
    x1: 63.7828,
    y1: 90.9551,
    x2: 63.7828,
    y2: 105.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECF74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_727_1630",
    x1: 55.2935,
    y1: 77.8511,
    x2: 55.2935,
    y2: 87.8249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECF74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_727_1630",
    x1: 51.2009,
    y1: 105.942,
    x2: 51.2009,
    y2: 114.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECF74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_727_1630",
    x1: 10.3213,
    y1: 100.823,
    x2: 10.3213,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_727_1630",
    x1: 69.8608,
    y1: 36.1113,
    x2: 69.8608,
    y2: 68.3686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECF74"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_1630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.884,
    height: 120,
    fill: "white",
    transform: "translate(0.769531)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/Navigation.ee94c168fd6ac59dbb61d8c9e85fb112.svg";
export { ForwardRef as ReactComponent };